/**
 * 后端响应数据结构定义
 * 与后端 TransformInterceptor 保持一致
 */

export interface ApiResponse<T = any> {
  data: T;
  message: string;
  state: string;
}

/**
 * 响应状态枚举
 */
export enum ResponseState {
  SUCCESS = "success",
  ERROR = "error",
  WARNING = "warning",
  INFO = "info",
}

/**
 * 错误信息接口
 */
export interface ErrorInfo {
  message: string;
  state: string;
  data?: any;
}

/**
 * 请求配置接口
 */
export interface RequestConfig {
  headers?: Record<string, string>;
  skipErrorHandler?: boolean;
}
